export default __webpack_public_path__ + "static/media/img-cwa-user-experience-01.27df9114.png";